import React, { useCallback, useState } from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';
import LinkRoundedIcon from '@material-ui/icons/LinkRounded';
import { Field, Formik } from 'formik';
import { isEmpty, isNil } from 'lodash';

import { colors } from 'theme/palette';
import { addExampleValidationSchema } from 'utils/schemas';

import AddButton from 'components/AddButton';
import Button from 'components/Button';
import InputField from 'components/InputField';

import styles from './styles.module.scss';

const initialValues = { attribution: '', url: '' };

const AddExample = ({ onSubmit }) => {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen((prev) => !prev), []);

  const onFormSubmit = useCallback(
    (values, { resetForm }) => {
      onSubmit(values);
      resetForm();
      toggle();
    },
    [onSubmit, toggle]
  );

  if (!open) {
    return (
      <AddButton variant="small" color="blue" onClick={toggle}>
        Add Example
      </AddButton>
    );
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={addExampleValidationSchema}
      onSubmit={onFormSubmit}
    >
      {({ isSubmitting, handleSubmit, submitForm, dirty, errors }) => (
        <form onSubmit={handleSubmit} className={styles.form}>
          <Field
            component={InputField}
            variant="underlined"
            name="attribution"
            placeholder="Name of Source (e.g., “PARCC”)"
            className={styles.input}
            error={!isNil(errors.attribution)}
            helperText={errors.attribution}
          />
          <Field
            component={InputField}
            variant="underlined"
            name="url"
            placeholder="Link to Example"
            className={styles.input}
            error={!isNil(errors.url)}
            helperText={errors.url}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <LinkRoundedIcon fontSize="small" htmlColor={colors.grey4} />
                </InputAdornment>
              )
            }}
          />
          <Button
            variant="small"
            color="blue"
            disabled={isSubmitting || !dirty || !isEmpty(errors)}
            onClick={submitForm}
          >
            Add
          </Button>
        </form>
      )}
    </Formik>
  );
};

export default React.memo(AddExample);
